export const INITIAL_STATE = {
    companies: [],
    isLoading: false,
    selectedRow: null,
    tablePage: 1,
    isRowSelected:false,
    searchValue: ''
};


// WEBPACK FOOTER //
// ./src/reducers/state/Company.js